import { FaSearch } from "react-icons/fa";
import { FaFileCircleXmark } from "react-icons/fa6";
import type { InputHTMLAttributes } from "react";

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
    onClear?: () => void;
}

function SearchBar({ onClear, value, ...rest }: SearchBarProps) {
    return (
        <label className="input bg-base-content/10 input-sm flex items-center gap-2 w-full py-2 z-30 h-8 rounded-lg">
            <FaSearch className="w-4 h-4 opacity-70" />
            <input
                type="text"
                className="grow peer bg-transparent"
                placeholder="Search"
                value={value}
                {...rest}
            />
            {value && value !== "" && (
                <FaFileCircleXmark
                    className="w-4 h-4 opacity-70 cursor-pointer transition-opacity duration-150"
                    onClick={onClear}
                    tabIndex={0}
                    aria-label="Clear search"
                />
            )}
        </label>
    );
}


export default SearchBar
